import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styles from './TableActions.module.scss';
import { ActionExport } from './components/ActionExport/ActionExport';
import { ActionColumnManager } from './components/ActionColumnManager/ActionColumnManager';
import { ActionCurrency } from './components/ActionCurrency/ActionCurrency';
import { tableActions } from './TableActions.const';
import { CSVExportType } from '../../../common';

interface TableActionsProps {
	filters: string[];
	exportData: CSVExportType;
	children?: React.ReactNode;
}

const TableActions: FC<TableActionsProps> = ({ filters, exportData, children }): JSX.Element => {
	return (
		<section className={styles.TableActions}>
			<div className={styles.FirstBox}>
				{filters.includes(tableActions.EXPORT) && <ActionExport data={exportData} />}
				{filters.includes(tableActions.CURRENCY) && <ActionCurrency />}
				{children}
			</div>
			{filters.includes(tableActions.COLUMNS) && <ActionColumnManager />}
		</section>
	);
};

TableActions.propTypes = {
	filters: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};

export { TableActions };
